import { css } from 'linaria';

export const stepsSection = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--only-desktop) {
    margin-bottom: 86px;
  }

  @media (--only-tablet) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 48px;
  }
`;

export const stepsSectionTitle = css`
  margin-bottom: 32px;

  @media (--only-tablet) {
    margin-bottom: 24px;
  }

  @media (--only-mobile) {
    margin-bottom: 16px;

    && {
      font-weight: 500;
      font-size: 22px;
      line-height: 28px;
    }
  }
`;

export const stepList = css`
  display: flex;
  justify-content: space-between;

  @media (--to-desktop) {
    flex-direction: column;
  }
`;

export const shortStepList = css`
  @media (--only-largeDesktop) {
    justify-content: unset;
  }
`;

export const stepContainer = css`
  width: 280px;

  @media (--only-desktop) {
    width: 211px;
  }

  @media (--to-desktop) {
    display: flex;
    width: 100%;
  }

  @media (--only-tablet) {
    margin-bottom: 32px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  @media (--only-mobile) {
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const shortStepContainer = css`
  @media (--only-largeDesktop) {
    margin-right: 120px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  @media (--only-desktop) {
    width: 292px;
  }
`;

export const stepNumberWrapper = css`
  width: 40px;
  height: 40px;
  margin-bottom: 16px;

  @media (--to-desktop) {
    margin-bottom: 0;
  }

  @media (--only-tablet) {
    margin-right: 16px;
  }

  @media (--only-mobile) {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }
`;

export const stepNumber = css`
  display: block;
  width: 40px;
  height: 40px;
  font-weight: 500;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  color: var(--control-invert);
  background-color: var(--control-primary);
  border-radius: 50%;

  @media (--only-mobile) {
    width: 24px;
    height: 24px;
    font-size: 14px;
    line-height: 24px;
  }
`;

export const stepName = css`
  @media (--only-desktop) {
    margin-bottom: 8px;
  }

  @media (--only-tablet) {
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 22px;
  }

  @media (--only-mobile) {
    margin-bottom: 2px;
  }
`;

export const stepDescription = css`
  @media (--only-tablet) {
    max-width: 604px;
    font-size: 14px;
    line-height: 18px;
  }
`;
